export class ExternalServices{
    public static executeAction(intent:string, typeGuid:string, objectName:string, content:string){
        (window.external as any).ExecuteAction(intent, typeGuid, objectName, content);
    }

    public static async executeRequest(intent:string, type:string, typeGuid:string, objectName:string, content:string, token:string):Promise<string>{
        return await (window.external as any).ExecuteRequest(intent, type, typeGuid, objectName, content, token);
    }
}